/**
 * Donation form scripts
 */
export default function donateSection() {
      [...document.querySelectorAll('[sw-donate]')].forEach(container => {

            // Get the form
            const form = container.querySelector('#donationForm');
            if (!form) return;

            // Get context elements
            const donationLabel = form.querySelector('#donation-label'),
                  donationAmount = form.querySelector('#donation-amount'),
                  donationBoxInput = form.querySelector('.donation-box .donation-box_input');
            if (!donationBoxInput || !donationAmount) return;

            /**
             * Formats the donation amount input box (prepend the dollar sign)
             * @param {String} [value]
             */
            const formatDonationInputValue = (value = null) => {
                  value = value || (donationBoxInput.value || form.dataset.defaultDonation);
                  donationBoxInput.value = `$${value.replace('$', '')}`;
            }

            // Format donation amount input on blur
            donationBoxInput.addEventListener('blur', () => formatDonationInputValue());

            // Enable donation amount input on click
            donationBoxInput.addEventListener('click', () => donationBoxInput.removeAttribute('disabled'));

            // Key input control for donation amount
            donationBoxInput.addEventListener('keydown', event => {
                  const allow = ['Backspace', 'ArrowLeft', 'ArrowRight'];
                  if ((isNaN(event.key) || event.key === " ") && !allow.includes(event.key)) event.preventDefault();
            });

            // Radio button changes
            [...form.querySelectorAll('input[type="radio"]')].forEach(radio => {
                  radio.addEventListener('change', () => {

                        // Switch value
                        const input = donationBoxInput.value.replace('$', '');
                        formatDonationInputValue(+input >= form.dataset.defaultDonation ? input : radio.value);

                        // Hide the donation amount input if radio preset is zero
                        donationBoxInput.parentElement.style.display = (+radio.value > 0) ? 'inline-block' : 'none';

                        // Update purpose (item_name for PayPal)
                        const purpose = radio.parentElement.dataset.purpose;
                        if (purpose) donationLabel.value = `${donationLabel.value.split(' - ')[0]} - ${purpose}`;
                  });
            });

            // Set post value and disable
            form.addEventListener('submit', () => {
                  donationBoxInput.setAttribute('disabled', '');
                  const amount = donationBoxInput.parentElement.style.display === 'none' ? 0 : donationBoxInput.value.replace('$', '');
                  donationAmount.value = isNaN(amount) ? 0 : amount;
            });
      });
}



// WEBPACK FOOTER //
// ./source/scripts/sections/donate.js